var _defs, _g, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecipeEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    zoomAndPan: "magnify",
    viewBox: "0 0 75 74.999997",
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1319458a0a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.5 7.5 L 67.5 7.5 L 67.5 67.5 L 7.5 67.5 Z M 7.5 7.5 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1319458a0a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#723fa3",
    d: "M 37.5 7.5 C 20.957031 7.5 7.5 20.957031 7.5 37.5 C 7.5 54.042969 20.957031 67.5 37.5 67.5 C 54.042969 67.5 67.5 54.042969 67.5 37.5 C 67.5 20.957031 54.042969 7.5 37.5 7.5 Z M 37.5 65.394531 C 22.097656 65.394531 9.605469 52.902344 9.605469 37.5 C 9.605469 22.097656 22.097656 9.605469 37.5 9.605469 C 52.902344 9.605469 65.394531 22.097656 65.394531 37.5 C 65.394531 52.902344 52.902344 65.394531 37.5 65.394531 Z M 37.5 65.394531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#723fa3",
    d: "M 52.605469 27.835938 L 42.449219 37.5 L 52.605469 47.164062 C 52.875 46.792969 53.050781 46.378906 53.125 45.925781 L 53.125 29.074219 C 53.050781 28.621094 52.875 28.207031 52.605469 27.835938 Z M 52.605469 27.835938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#723fa3",
    d: "M 37.5 42.207031 L 33.320312 38.230469 L 23.171875 47.886719 C 23.648438 48.203125 24.175781 48.359375 24.746094 48.359375 L 50.253906 48.359375 C 50.824219 48.359375 51.351562 48.203125 51.828125 47.886719 L 41.679688 38.230469 Z M 37.5 42.207031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#723fa3",
    d: "M 22.394531 27.835938 C 22.125 28.207031 21.949219 28.621094 21.875 29.074219 L 21.875 45.925781 C 21.949219 46.378906 22.125 46.792969 22.394531 47.164062 L 32.550781 37.5 Z M 22.394531 27.835938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#723fa3",
    d: "M 33.320312 36.769531 L 37.5 40.753906 L 51.828125 27.113281 C 51.351562 26.796875 50.824219 26.640625 50.253906 26.640625 L 24.746094 26.640625 C 24.175781 26.640625 23.648438 26.796875 23.171875 27.113281 Z M 33.320312 36.769531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipeEmailIcon);
export default __webpack_public_path__ + "static/media/Recipe - Email Icon.9d729cfa869ff4c5e2be77dcb33665d0.svg";
export { ForwardRef as ReactComponent };